import React from 'react'
import PropTypes from 'prop-types'

const values = (obj)=> Object.keys(obj).map(key => obj[key])

const IMAGE_FORMATS = {
  // png8 or png (default) specifies the 8-bit PNG format.
  PNG: 'png',

  // png32 specifies the 32-bit PNG format.
  PNG32: 'png32',

  // gif specifies the GIF format.
  GIF: 'gif',

  // jpg specifies the JPEG compression format.
  JPG: 'jpg',

  // jpg-baseline specifies a non-progressive JPEG compression format.
  JPG_BASELINE: 'jpg-baseline'
}

const MAP_TYPES = {
  // roadmap (default) specifies a standard roadmap image, as is normally shown on the Google Maps website.
  ROADMAP: 'roadmap',

  // satellite specifies a satellite image.
  SATELLITE: 'satellite',

  // terrain specifies a physical relief map image, showing terrain and vegetation.
  TERRAIN: 'terrain',

  // hybrid specifies a hybrid of the satellite and roadmap image,
  // showing a transparent layer of major streets and place names on the satellite image.
  HYBRID: 'hybrid'
}

const IMAGE_FORMATS_VALUES = values(IMAGE_FORMATS)
const MAP_TYPES_VALUES = values(MAP_TYPES)

class GoogleStaticMap extends React.Component {

  static ApiKey = process.env.GOOGLE_STATIC_MAPS_KEY

  static RootUrl = 'https://maps.googleapis.com/maps/api/staticmap'

  static ImageFormats = IMAGE_FORMATS

  static MapTypes = MAP_TYPES

  static defaultProps = {
    format: IMAGE_FORMATS.PNG,
    mapType: MAP_TYPES.ROADMAP,
    hasCenterMarker: true
  }

  get markerParams() {
    const {
      latitude,
      longitude,
      hasCenterMarker
    } = this.props

    const markerParams = `markers=size:mid%7Ccolor:0x34EF77%7C${latitude},${longitude}`
    return hasCenterMarker ? markerParams : ''
  }

  get apiKeyParam() {
    const apiKey = this.constructor.ApiKey
    return apiKey ? `key=${apiKey}` : ''
  }

  get staticMapUrl() {
    const {
      query,
      latitude,
      longitude,
      zoom,
      size,
      scale,
      format,
      mapType
    } = this.props

    const { width, height } = size
    const rootUrl = this.constructor.RootUrl

    const mapStyles = "&style=feature:administrative%7Celement:labels%7Ccolor:0xFFFFFF%7Cvisibility:simplified&style=feature:landscape.man_made%7Ccolor:0x424244%7Cvisibility:simplified&style=feature:landscape.natural%7Celement:geometry%7Ccolor:0x1e1e21%7Cvisibility:simplified&style=feature:poi%7Celement:geometry%7Cvisibility:off&style=feature:poi%7Celement:labels.text%7Ccolor:0xb4b4b6%7Cvisibility:simplified&style=feature:road%7Celement:geometry%7Ccolor:0x808080%7Cvisibility:simplified&style=feature:road%7Celement:labels.icon%7Cvisibility:off&style=feature:road%7Celement:labels.text%7Ccolor:0xb4b4b6%7Cvisibility:simplified&style=feature:transit.station.airport%7Csaturation:-100%7Clightness:-41%7Cgamma:0.79%7Cvisibility:on&style=feature:water%7Ccolor:0x666668"

    const center = (latitude && longitude) ? `center=${latitude},${longitude}&` : `center=${query}&`
    return `${rootUrl}?${center}zoom=${zoom}&scale=${scale}&size=${width}x${height}&maptype=${mapType}&format=${format}&${this.markerParams}&${this.apiKeyParam}${mapStyles}`
  }

  render() {
    return (
      <img
        className={this.props.className}
        src={this.staticMapUrl}
      />
    )
  }
}

GoogleStaticMap.propTypes = {
  className: PropTypes.string,
  query: PropTypes.string,
  latitude: PropTypes.string,
  longitude: PropTypes.string,
  size: PropTypes.object.isRequired,
  zoom: PropTypes.number.isRequired,
  scale: PropTypes.number,
  format: PropTypes.oneOf(IMAGE_FORMATS_VALUES),
  mapType: PropTypes.oneOf(MAP_TYPES_VALUES),
  hasCenterMarker: PropTypes.bool
}

GoogleStaticMap.contextTypes = {
  tintColor: PropTypes.string
}


export default GoogleStaticMap
